export enum StudentTour {
  UNITS,
  ALL_SKILLS,
  UNIT_SELECTION,
}
